import styled from "styled-components";

import { Button } from "react-bootstrap";

export const CtaButton = styled(Button)`
  display: inline-block;
  border: 2px solid #39b54a;
  text-transform: uppercase;
  color: #39b54a;

  &:hover,
  &:focus {
    background-color: #39b54a;
    border: 2px solid #39b54a;
    color: white;
  }
`;

export const Title = styled.h3`
  text-align: center;
  text-transform: uppercase;

  &:after {
    content: "";
    display: block;
    height: 2px;
    background: #39b54a;
    width: 10%;
    margin: 1rem auto 2rem auto;
    border-radius: 1rem;
  }
`;
